import React, { useEffect, useState } from "react";
import "./QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-fields';
import bc from "../../images/book-cover.svg";
import com from "../../images/compass-icon.svg";
import sh from "../../images/shield.svg";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import axios from "axios";
import ff from "../../images/pp-logo.gif";

function QuizHub({token}) {

  const [loading, setLoading] = useState(true);

    const [quiz, setquiz] = useState([]);

    const [pageDetail, setpageDetail] = useState([]);

    const [error, setError] = useState("");

    useEffect(() => {

        fetchQuiz();

    }, []);

    const fetchQuiz = async () => {

        try {

            setLoading(true);

            const response = await axios.get(

                `${END_URL}/quiz-list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {

                setquiz(response.data.data || []);

                setpageDetail(response.data.page_detail||[]);

            } else {

                setError("Failed to load ebooks");
            }

        } catch (error) {

            console.log(error);

            setError("Something went wrong");

        } finally {

            setLoading(false);
        }
    };

    if (loading) {  

        return (
            <div className="loadingDiv">
                <img src={ff} alt="Loading..." />
            </div>
        );
    }

  return (
    <div className="quizhub-cont">
      <div className="ques-main quizhub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">

              <div className="ques-top" style={{'--bg-image': `url(${IMG_URL}/d0/${pageDetail?.quiz_list_banner_image})` }} >

                <div className="ques-top-title" dangerouslySetInnerHTML={{__html:pageDetail?.quiz_list_banner_content}} />
            
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="container">

        <div className="row quizhub-book-cards-row">

          {quiz?.map((item, index) => {

            return (

                  item?.quizlist?.quiz_image && item?.quizlist?.quiz_image && (

                    <div className="col-md-4">

                      <div className="quiz-box">

                        <div className="quiz-imgDiv">

                          <img src={`${IMG_URL}/d0/${item?.quizlist?.quiz_image}`} alt="" />

                        </div>

                        {item?.quizlist?.main_quiz == 1 && (

                          <span className="quiz-top">MAIN QUIZ</span>

                        )}

                        <div className="quizhub-content">

                          <h6>{item?.quizlist?.test_show_name}</h6>
                          
                          <div dangerouslySetInnerHTML={{__html:item?.quizlist?.quiz_description}}/>
                          
                          <div className="quizhub-btn">

                            <a href={`${item?.quizlist?.take_button_link}`}  class="new-commom-btn quizhub-take">

                              <span>{pageDetail?.quiz_take_now_button_label}</span>

                              <span class="righ-arr">
                                <FontAwesomeIcon icon={faArrowRight} />
                              </span>
                            </a>

                            <a href={`${item?.quizlist?.about_quiz_link}`} class="new-commom-btn quiz-about">

                              <span>{pageDetail?.quiz_take_now_button_link}</span>

                              <span class="righ-arr">
                                <FontAwesomeIcon icon={faInfoCircle} />
                              </span>
                            </a>
                          </div>

                        </div>
                      </div>
                    </div>

                  )

                );
          })}

        </div>

        <div className="row ">
          <div className="adapter-cta-div adapter-cta-div-in-ebook">
            <div className="adapt-cta-img">
              <div>
                <span>
                  <img src={`${IMG_URL}/d0/${pageDetail?.quiz_footer_image}`} alt="" />
                </span>
              </div>
            </div>

            <div className="adapt-cta-text" dangerouslySetInnerHTML={{__html:pageDetail?.quiz_footer_content}}/>
        
            <div className="adapt-cta-btn">

              {pageDetail?.quiz_footer_start_button_label && pageDetail?.quiz_footer_start_button_link && (

                <a href={`${pageDetail?.quiz_footer_start_button_link}`} class="new-commom-btn adapter-btn">

                  <span>{pageDetail?.quiz_footer_start_button_label}</span>

                  <span class="righ-arr">

                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

              )}

            </div>
          </div>
        </div>
      </div>

      <div className="quizhub-unique">
        <div className="container">
          <div className="row quizhub-unique-outer-row">

            {pageDetail?.quiz_badege_content_1 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_1}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_1}} />
                        

                    </div>
                </div>
            )}

            {pageDetail?.quiz_badege_content_2 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_2}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_2}} />
                        

                    </div>
                </div>
            )}

            {pageDetail?.quiz_badege_content_3 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_3}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_3}} />
                        

                    </div>
                </div>
            )}

              {pageDetail?.quiz_badege_content_4 && (

                <div className="col-md-3">
                      <div className="quizhub-unibox">
                          <span>
                            <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_content_4}`} alt="" />
                          </span>

                          <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_4}} />
                          

                      </div>
                  </div>
              )}


          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizHub;
